import React from 'react';
import { CreatableSelectField, Grid, NumberField, SelectField } from '../../../../ui-toolkit';
import { Show } from '../../../shared/Show';
import { eSigningMethod, signingMethodsNotRequiringWitness } from '../../../../types/signingAppointment/eSigningMethod';
import { languageOptions, witnessOptions } from '../commonOptions';
import { WitnessTooltip } from '../Reusable/WitnessTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ISigningAppointmentResponse } from '../../../../types/signingAppointment/ISigningAppointmentResponse';
import { useFormikContext } from 'formik';
import { ISigningAppointmentEditFormData } from '../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { showRate } from '../utilities/showRate';

export const RateLanguageWitness: React.FC<{
  appointmentFromPath: ISigningAppointmentResponse;
  selectedSigningMethod: string;
}> = ({ appointmentFromPath, selectedSigningMethod }) => {
  const { values } = useFormikContext<ISigningAppointmentEditFormData>();

  if (selectedSigningMethod === eSigningMethod.wetSign) {
    return null;
  }

  return (
    <Grid columnCount={4} templateColumns={'.25fr .3fr .25fr .25fr'}>
      <Show when={showRate(selectedSigningMethod, appointmentFromPath.isSignatureSyncAppointment)}>
        <NumberField name={'rateCents'} mode={'currency'} label={`Rate`} valueIsCents />
      </Show>
      <Show when={selectedSigningMethod !== eSigningMethod.thirdPartyNotary}>
        <CreatableSelectField
          menuPlacement="top"
          name="language"
          label="Preferred Language"
          placeholder={`Select a language`}
          options={languageOptions}
        />
      </Show>
      <Show when={selectedSigningMethod !== eSigningMethod.eSign}>
        <SelectField
          menuPlacement="top"
          name={'witness'}
          options={witnessOptions}
          label={
            <>
              Witness
              <WitnessTooltip>
                <FontAwesomeIcon icon={faInfoCircle} className={'ml-1'} />
              </WitnessTooltip>
            </>
          }
          isDisabled={signingMethodsNotRequiringWitness.includes(values.signingMethod ?? '')}
        />
      </Show>
    </Grid>
  );
};
